import React from "react";
import ThreeScene from "../components/ThreeScene";
import Hero from "../components/Hero";
import Projects from "../components/Projects";
import TicTacToe from "../components/TicTacToe";
import { Mail, Download } from "lucide-react";
import {
  GitHubIcon,
  LinkedInIcon,
  TwitterIcon,
} from "../components/SocialIcons";

const Landing = () => {
  return (
    <div className="landing-root">
      <ThreeScene />

      <nav className="navbar glass-card">
        <div className="nav-container">
          <div className="logo">Portfolio.</div>
          <div className="nav-links">
            <a href="#projects">Work</a>
            <a href="#about">About</a>
            <a href="#game">Play</a>
            <a
              href="https://drive.google.com/uc?export=download&id=YOUR_FILE_ID"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-resume-btn"
            >
              <Download size={16} /> Resume
            </a>
            <a
              href="#contact"
              className="btn btn-primary btn-sm"
              style={{ color: "white" }}
            >
              Let's Talk
            </a>
          </div>
        </div>
      </nav>

      <main>
        <Hero />

        <section id="about" className="container">
          <div className="glass-card about-content">
            <h2 className="section-title">
              A Bit <span className="gradient-text">About Me</span>
            </h2>
            <p className="large-text">
              With 2.5 years of hands-on experience in the fullstack world, I've
              found my rhythm in React.js and FastAPI — crafting interfaces that
              feel intuitive and backends that are built to last. And I don't
              limit myself there. Frontend, backend, any language, any stack — I
              embrace the challenge, grow through it, and deliver with care.
              Technology has always felt like a natural conversation to me. I
              believe good software is more than working code — it's thoughtful
              architecture, built with intention. I'm not chasing titles; I'm
              quietly but steadily walking the path of becoming a truly great
              Software Engineer. It's not a race — it's a lifelong commitment
              I've made to my craft and to myself. Curiosity keeps me going.
              Growth keeps me grounded. And every line of code I write is a
              small step toward something bigger — a version of myself I'm
              always working toward.
            </p>
            <div className="skills-grid">
              <div className="skill-category">
                <h4>Frontend</h4>
                <p>React, Next.js, Three.js, CSS/SCSS, TypeScript</p>
              </div>
              <div className="skill-category">
                <h4>Backend</h4>
                <p>Node.js, Express, Python, FastAPI, Go</p>
              </div>
              <div className="skill-category">
                <h4>DevOps</h4>
                <p>AWS, Docker, CI/CD, Terraform</p>
              </div>
            </div>
          </div>
        </section>

        <Projects />

        <section id="game" className="container">
          <div style={{ textAlign: "center", marginBottom: "2rem" }}>
            <h2 className="section-title">
              Need a <span className="gradient-text">Break?</span>
            </h2>
            <p className="text-muted">
              Challenge yourself to a quick game of Tic Tac Toe.
            </p>
          </div>
          <TicTacToe />
        </section>

        <section id="contact" className="container">
          <div className="glass-card contact-card">
            <h2 className="section-title">
              Ready to <span className="gradient-text">Collaborate?</span>
            </h2>
            <p>
              I'm always open to new opportunities and interesting projects.
            </p>
            <div className="contact-links">
              <a href="mailto:debadutta@gamil.com" className="contact-link">
                <Mail />
                debadutta@gamil.com
              </a>
              <div className="social-links">
                <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                  <GitHubIcon />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <LinkedInIcon />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <TwitterIcon />
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>&copy; 2026 Portfolio. Crafted with Passion.</p>
      </footer>
    </div>
  );
};

export default Landing;
